import { useEffect } from "react";
import { getCelebrationStore, useCelebrationStore } from "src/providers/CelebrationProvider";

const useCelebration = () => {
	useEffect(() => {
		const { registerHook } = getCelebrationStore();
		const unsubscribe = registerHook();

		return () => {
			unsubscribe();
		};
	}, []);

	const queueConfettiCannon = useCelebrationStore((state) => state.queueConfettiCannon);

	return {
		launchConfettiCannon: queueConfettiCannon,
	};
};
export default useCelebration;
